import React, { useEffect, useState } from "react";

import api from "../../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "../loader";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import numeral from "numeral";

function ChallengesAdmin({ adminType }) {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [data, setData] = useState([]);
  const [noOfChallengs, setNoOfChallengs] = useState(0);
  const [loader, setLoader] = useState(true);
  const [inputData, setInputData] = useState({});
  const [resetPage, setResetPage] = useState(false);
  const [firstRender, setfirstRender] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = (item) => {
    setSelectedData(item);
    setShow(true);
  };

  // console.log(window.location);
  // console.log(match.url);
  const getChallenges = async () => {
    try {
      let payload = {};
      payload = {
        page: page,
        ...inputData,
      };
      setLoader(true);
      const userData = await api.AdminChallenges(payload);
      // console.log(userData);
      if (userData?.success) {
        setData(userData.data);
        setNoOfChallengs(userData.totalItems);
      }
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  const searchFilter = () => {
    if (page == 1) {
      getChallenges();
    } else {
      setPage(1);
    }
  };

  const handleReset = () => {
    setInputData({});
    setResetPage(!resetPage);
    setPage(1);
  };

  useEffect(() => {
    getChallenges();
  }, [page]);

  useEffect(() => {
    if (inputData?.status) {
      searchFilter();
    }
  }, [inputData]);

  return (
    <>
      <div className="container-fluid payHistoryPage">
        <div className="row">
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-12   d-flex justify-content-between pr-0 flex-wrap">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  Challenges ({noOfChallengs})
                </h4>
              </div>
            </div>
            <div className="SupportfilterM row mx-0">
              <div className="col-12">
                <div className="fRow">
                  <div className="me-3">Filter:</div>

                  <div className="form-group my-3 me-3 position-relative">
                    <i className="fa-solid fa-caret-down  arrowDownIco" />

                    <select
                      name="status"
                      id=""
                      onChange={(e) =>
                        setInputData({
                          ...inputData,
                          status: e.target.value,
                        })
                      }
                      value={inputData?.status}
                      className="form-control ng-dirty ng-invalid ng-touched"
                    >
                      <option value="">Select Status</option>
                      <option
                        value="active"
                        selected={inputData?.status == "active" ? true : false}
                      >
                        Active
                      </option>
                      <option
                        value="won"
                        selected={inputData?.status == "won" ? true : false}
                      >
                        Won
                      </option>
                      <option
                        value="lost"
                        selected={inputData?.status == "lost" ? true : false}
                      >
                        Lost
                      </option>
                      <option
                        value="exited"
                        selected={inputData?.status == "exited" ? true : false}
                      >
                        Exited
                      </option>
                    </select>
                  </div>

                  <button
                    className="themeBlackBtn"
                    onClick={() => handleReset()}
                  >
                    Reset Filter
                  </button>
                </div>
              </div>
            </div>
            {/* table */}
            <Table
              data={data}
              setPage={setPage}
              page={page}
              noOfChallengs={noOfChallengs}
              limit={limit}
              handleShow={handleShow}
            />
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}

      <Modal show={show} size="lg" onHide={handleClose} centered className="">
        <Modal.Body>
          <div className="otpModalMain">
            <div className="closeIcon" onClick={handleClose}>
              <i className="fa-solid fa-xmark" />
            </div>
            <div className="showChalengeModal">
              <div className="h3 m4-2 mt-3 text-center">Challenge</div>
              <div className="table-responsive">
                <table className="table table-bordered bordered">
                  {Object.entries(selectedData).map((item, key) =>
                    item[0] == "userId" ? (
                      <tr>
                        <th>{item[0]}</th>
                        <td>{item[1]?.email}</td>
                      </tr>
                    ) : (
                      <tr>
                        <th>{item[0]}</th>
                        <td>{item[1]}</td>
                      </tr>
                    )
                  )}
                </table>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
const Table = ({ data, page, setPage, noOfChallengs, limit, handleShow }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);

  const navigate = useNavigate();
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Challenge Name
                  </th>
                  <th scope="col" className="">
                    User (email)
                  </th>
                  <th scope="col" className="">
                    Status
                  </th>
                  <th scope="col" className="">
                    Start date
                  </th>
                  <th scope="col" className="">
                    Deadline
                  </th>
                  <th scope="col" className="">
                    Initial Balance
                  </th>
                  <th scope="col" className="">
                    Target Balance
                  </th>
                  <th scope="col" className="">
                    Reward
                  </th>
                  <th scope="col" className="">
                    Total Trades
                  </th>
                  <th scope="col" className="">
                    Challenge Balance
                  </th>
                  <th scope="col" className="">
                    View
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.name}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.userId?.email}
                        <i
                          className="fa-solid fa-arrow-up-right-from-square p-2 cursor-pointer"
                          onClick={() =>
                            navigate(
                              `/admin/challenges/user/${item?.userId?._id}`
                            )
                          }
                        ></i>
                        {/* /admin/challenges/user/ */}
                      </div>
                    </td>

                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.status}
                      </div>
                    </td>

                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {formatDate(item?.startDate)}
                      </div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {formatDate(item?.endDate)}
                      </span>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {numeral(item?.initialBalance).format("$0,0")} USD
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {numeral(item?.targetBalance).format("$0,0")} USD
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {numeral(item?.reward).format("$0,0")} USD
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {item?.totalTrades}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {numeral(item?.challengeBalance).format("$0,0")} USD
                      </div>
                    </td>

                    <td>
                      <i
                        className="fa-solid fa-eye cursor-pointer"
                        onClick={() => handleShow(item)}
                      ></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-center">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfChallengs / limit)}
                page={page}
                onChange={handleChange}
              />
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChallengesAdmin;
